export const ERROR_MESSAGES = {
  location: {
    oneway: 'Por favor, insira o local ou aeroporto para aluguel do carro.',
    pickup: 'Por favor, insira um local para retirada.',
    dropoff: 'Por favor, insira um local para devolução.',
  },
  dates: {
    pickup: 'Por favor, insira uma data para retirada.',
    dropoff: {
      emptyField: 'Por favor, insira uma data para devolução.',
      sameDate: 'Escolha uma data diferente para a devolução.',
    },
  },
  time: {
    pickup: 'Por favor, insira um horário para retirada.',
    dropoff: 'Por favor, insira a hora da devolução.',
  },
};
